var _title, _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCircledDownFilled = function SvgCircledDownFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons8-circled_down_2_filled")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-445.000000, -89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-circled_down_2_filled",
    transform: "translate(445.000000, 89.000000)",
    fill: "#2C3543",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0 C3.36404543,0 0,3.36404543 0,7.5 C0,11.6359546 3.36404543,15 7.5,15 C11.6346805,15 15,11.6359546 15,7.5 C15,3.36404543 11.6346805,0 7.5,0 Z M9.90699405,8.6946256 L7.36731143,11.3319882 C7.33878985,11.3628948 7.30282731,11.3860749 7.26438508,11.4028159 C7.22594254,11.4195569 7.18377968,11.4285714 7.14285714,11.4285714 C7.1019346,11.4285714 7.05977174,11.4195569 7.02132952,11.4028159 C6.98288698,11.3860749 6.94816476,11.3628948 6.91840285,11.3319882 L4.37872024,8.6946256 C4.2547123,8.56584813 4.2547123,8.35722879 4.37872024,8.22845132 C4.50272818,8.09967385 4.70362088,8.09967385 4.82762882,8.22845132 L6.82539682,10.3030565 L6.82539682,3.18681319 C6.82539682,3.00523703 6.96800603,2.85714286 7.14285714,2.85714286 C7.31770826,2.85714286 7.46031747,3.00523703 7.46031747,3.18681319 L7.46031747,10.3030565 L9.45808546,8.22845132 C9.5820934,8.09967385 9.78298611,8.09967385 9.90699405,8.22845132 C10.031002,8.35722879 10.031002,8.56584813 9.90699405,8.6946256 Z",
    id: "Shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircledDownFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circled_down_filled.444d62cc.svg";
export { ForwardRef as ReactComponent };